<template>
    <record-delete-item
        v-bind:recordData="source"
        v-bind:itemFunc="clickSearchResultItem">
    </record-delete-item>
</template>

<script>
import RecordDeleteItem from '../record/RecordDeleteItem.vue'
export default {
    name: 'SearchResultItem',
    components: { RecordDeleteItem },
    props: {
        source: {   
            type: Object,
            default () { return {} }
        }
    },
    methods: {
        clickSearchResultItem(recordData) {
            var personInfo = this.$store.state.record.recordOriginalData[recordData.id];
            this.$store.dispatch('detail/initDetail', personInfo);
            // 更新列表数据
            this.$store.dispatch('record/updateRecordListData', personInfo);
            this.$router.replace('/detail/search/'+ personInfo.id);
        }
    }
}
</script>